import React from 'react';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { ImGooglePlus } from 'react-icons/im';
import app from './firebase.init';
import { setUserInfo } from '../../features/user/userSlice';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useCreateTokenMutation } from '../../features/api/apiSlice';

const provider = new GoogleAuthProvider();
const auth = getAuth(app);

const LoginWithGoogle = () => {
  const [createToken, { data: token, isError, isSuccess }] = useCreateTokenMutation();

  const dispatch = useDispatch();

  let navigate = useNavigate();
  let location = useLocation();

  let { from } = location.state || { from: { pathname: "/" } };
  
  const signInGoogle = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        if (user) {
          dispatch(setUserInfo(user));
          // console.log(user)
          createToken({
            email: user.email,
            uid: user.uid,
            photo: user.photoURL,
            emailVerified: user.emailVerified
          });
          navigate(from);
        }
      }).catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // console.log(errorCode, errorMessage, email, credential)
        if (error) {
          toast.error(`${errorMessage}!!!`, {
            position: "bottom-left",
          });
        }
      });
  }

  return (
    <>
      <div onClick={signInGoogle} className="cursor-pointer w-full border py-2 my-1.5 rounded text-white bg-[#D34836] text-xl font-poppins flex justify-center gap-4"> <ImGooglePlus className='mt-0.5 text-2xl' /> Google</div>
    </>
  );
};

export default LoginWithGoogle;